module.exports = __webpack_public_path__ + "fonts/Roboto-LightItalic.5788d5ce.ttf";